<template>
  <div>
    <el-dialog
        custom-class="verify-dialog-box"
        v-bind="$attrs"
        v-on="$listeners"
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="isShow"
        width="500px">
        <div class="flex-center">
            <VerifyTac
                ref="verifyTacRef"
                @btn-on-close="btnOnCloseHandler"
                @valid-success="validSuccessHandler"
            />
        </div>
    </el-dialog>
  </div>
</template>

<script>
import VerifyTac from './VerifyTac.vue'

export default {
  name: 'Verify',
  components: {
    VerifyTac
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShow: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data () {
    return {

    }
  },
  watch: {
    isShow: {
      handler (val) {
        this.$nextTick(() => {
          if (val && this.$refs.verifyTacRef) {
            this.$refs.verifyTacRef.init()
          }
        })
      },
      immediate: true
    }
  },
  methods: {
    btnOnCloseHandler () {
      this.isShow = false
      this.$emit('btn-close')
    },
    validSuccessHandler (res, tac) {
      this.$emit('valid-success', res, tac)
    }
  }
}

</script>

<style lang="scss">
.verify-dialog-box{
    background: transparent !important;
    box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Verify/index.vue